import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm4.586 14.423a.623.623 0 0 1-.857.207c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 1 1-.277-1.215c3.809-.871 7.076-.496 9.712 1.114.294.18.387.564.207.858ZM17.81 13.7a.78.78 0 0 1-1.073.257c-2.687-1.652-6.785-2.13-9.964-1.166A.78.78 0 0 1 6.32 11.3c3.631-1.102 8.146-.569 11.233 1.328a.78.78 0 0 1 .257 1.072Zm.105-2.835c-3.223-1.914-8.54-2.09-11.618-1.157a.935.935 0 1 1-.543-1.79c3.533-1.072 9.405-.865 13.116 1.338a.935.935 0 0 1-.955 1.609Z" }, null, -1)
  ])))
}
export default { render: render }